import useTranslation from 'next-translate/useTranslation';

import { Button, ButtonProps } from '@core/component';
import { Translate } from '@core/constant';
import { EButtonVariant, EIcon } from '@core/type';

import { ButtonAutoSavingsProps } from './interface-product-card';

export const ButtonAutoSavings = ({
  title,
  ...buttonProps
}: ButtonProps & ButtonAutoSavingsProps): JSX.Element => {
  const { t } = useTranslation(Translate.common.PRODUCT);

  return (
    <Button startIcon={EIcon.CART_REPEAT} variant={EButtonVariant.OUTLINED} {...buttonProps}>
      {title || t('buttons.autoSavings')}
    </Button>
  );
};
